import { render } from "./FirebaseCopyPopup.vue?vue&type=template&id=2b59c450"
import script from "./FirebaseCopyPopup.vue?vue&type=script&lang=js"
export * from "./FirebaseCopyPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__